import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid } from '@mui/material';
import { useProviderSettings } from 'hooks/useProviderSettings';
import { updateServiceFeesMenu } from 'redux/actions/providers';
import ProviderConfirmImage from 'assets/icons/ProviderConfirm.png';
import ProviderServicingFee from 'pages/Providers/ProviderServicingFee';
import ConfirmProviderAction from 'components/Confirm/ConfirmProviderAction';
import ConfirmDialogProviderSettings from 'pages/Providers/ConfirmDialogProviderSettings';

const ProviderDeliveryOrPickUp = ({ disabled, type, isDirty, methods }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    data,
    openModal,
    handleClose,
    showFee,
    handleApplyServiceFee,
    handleApplyServiceFeeCancel,
    providers,
    convertNameByProvider,
    openModalProviderSettings,
    setOpenModalProviderSettings,
    TYPES,
    syncPosMenuServiceFee,
  } = useProviderSettings(methods, type);

  const {
    formState: { dirtyFields },
  } = methods;

  useEffect(() => {
    if (!showFee && dirtyFields.enabled) {
      const body = {
        menuId: '',
        provider: data?.srv,
        enabled: false,
        type: TYPES[type],
      };
      dispatch(updateServiceFeesMenu(body));
      syncPosMenuServiceFee(body);
    }
  }, [showFee]);

  return (
    <>
      <ConfirmDialogProviderSettings
        type={type}
        methods={methods}
        isOpen={openModalProviderSettings}
        handleConfirm={handleApplyServiceFee}
        handleClose={handleApplyServiceFeeCancel}
        provider={convertNameByProvider(data?.name)}
      />
      <Grid item xs={12}>
        <ProviderServicingFee type={type} methods={methods} />
      </Grid>
      <Grid item xs={12} sx={{ width: '100%', display: 'flex', justifyContent: 'end', pr: 2 }}>
        <Box>
          <Button
            id="providerSettingsApply"
            onClick={() => setOpenModalProviderSettings(true)}
            variant="contained"
            disabled={!isDirty || !disabled}
          >
            {t('orders_history.apply')}
          </Button>
        </Box>
      </Grid>
      <ConfirmProviderAction
        handleClose={handleClose}
        showModal={openModal}
        title={'settings.service_text'}
        description={'settings.service_desc'}
        label={providers[data?.srv]?.label}
        icon={ProviderConfirmImage}
        iconName={'ezCater'}
      />
    </>
  );
};

export default ProviderDeliveryOrPickUp;
